module.exports = __webpack_public_path__ + "img/img6.bd98d9e6.svg";